import * as React from 'react';

function LinkedinIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={21} height={21} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6zM6 9H2v12h4V9zM4 6a2 2 0 100-4 2 2 0 000 4z'
				stroke='#000'
				strokeOpacity={0.45}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default LinkedinIcon;
